import React, { PureComponent } from 'react';
import styles from './index.css';
const { callApp } = require('@ifeng-fe/callapp');
/**
 * 提示：试看五分钟
 */
class ShortTips extends PureComponent {
    constructor() {
        super(...arguments);
        this.spanHandleCalledApp = () => {
            const { callAppConfig } = this.props;
            callApp(callAppConfig);
        };
    }
    render() {
        const { mobileClosureTime } = this.props;
        return React.createElement("div", { className: styles.shortTips },
            "\u53EF\u8BD5\u770B",
            mobileClosureTime,
            "\u79D2\uFF0C\u53BB  ",
            React.createElement("span", { className: styles.fhxwkhd, onClick: this.spanHandleCalledApp }, "\u51E4\u51F0\u7F51\u65B0\u95FB\u5BA2\u6237\u7AEF"),
            "  \u89C2\u770B");
    }
}
export default ShortTips;
